import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"width":"100%"} }
const _hoisted_2 = {
  key: 0,
  style: {"margin-bottom":"8px"}
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "stats-grid" }
const _hoisted_5 = { class: "stat-value" }
const _hoisted_6 = { class: "stat-value" }
const _hoisted_7 = { class: "stat-value" }
const _hoisted_8 = { class: "stat-value" }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SubjectScoreInputSection = _resolveComponent("SubjectScoreInputSection")!
  const _component_ion_badge = _resolveComponent("ion-badge")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_popover = _resolveComponent("ion-popover")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ProgramItemContent = _resolveComponent("ProgramItemContent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showTargetScores)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_SubjectScoreInputSection, {
            title: _ctx.targetUser ? 'Student Prediction' : 'My Prediction',
            source: "overallTarget",
            targetUser: _ctx.targetUser,
            program: _ctx.program,
            readonly: !!_ctx.targetUser,
            fromDeckView: true
          }, null, 8, ["title", "targetUser", "program", "readonly"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      (_ctx.showProgramAdmissionData && (_ctx.program?.interviewArrangements || _ctx.program?.numOfPlaces || _ctx.program?.admissions?.length))
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_ion_badge, {
                class: "stat-badge",
                style: _normalizeStyle({ backgroundColor: _ctx.transparent ? 'transparent' : undefined })
              }, {
                default: _withCtx(() => [
                  _cache[2] || (_cache[2] = _createElementVNode("div", { class: "stat-label" }, "Past Mean", -1)),
                  _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.program?.admissions?.[0]?.scoreMean || '-'), 1)
                ]),
                _: 1,
                __: [2]
              }, 8, ["style"]),
              _createVNode(_component_ion_badge, {
                class: "stat-badge",
                style: _normalizeStyle({ backgroundColor: _ctx.transparent ? 'transparent' : undefined })
              }, {
                default: _withCtx(() => [
                  _cache[3] || (_cache[3] = _createElementVNode("div", { class: "stat-label" }, "Past LQ", -1)),
                  _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.program?.admissions?.[0]?.scoreLowerQuartile || '-'), 1)
                ]),
                _: 1,
                __: [3]
              }, 8, ["style"]),
              _createVNode(_component_ion_badge, {
                class: "stat-badge",
                style: _normalizeStyle({ backgroundColor: _ctx.transparent ? 'transparent' : undefined })
              }, {
                default: _withCtx(() => [
                  _cache[4] || (_cache[4] = _createElementVNode("div", { class: "stat-label" }, "Past Median", -1)),
                  _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.program?.admissions?.[0]?.scoreMedian || '-'), 1)
                ]),
                _: 1,
                __: [4]
              }, 8, ["style"]),
              _createVNode(_component_ion_badge, {
                class: "stat-badge",
                style: _normalizeStyle({ backgroundColor: _ctx.transparent ? 'transparent' : undefined }),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setPopoverOpen('seats', true, $event)))
              }, {
                default: _withCtx(() => [
                  _cache[6] || (_cache[6] = _createElementVNode("div", { class: "stat-label" }, "Seat", -1)),
                  _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.program?.numOfPlaces || '-'), 1),
                  _createVNode(_component_ion_popover, {
                    isOpen: _ctx.popoverState.seats,
                    event: _ctx.popoverEvent,
                    "dismiss-on-select": true,
                    onDidDismiss: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setPopoverOpen('seats', false, $event)))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_content, null, {
                        default: _withCtx(() => [
                          (_ctx.program?.admissions?.length && _ctx.program.admissions[0].bandACompRatio)
                            ? (_openBlock(), _createBlock(_component_ion_card, {
                                key: 0,
                                class: "ion-text-center",
                                color: _ctx.getCompetitivenessColor(_ctx.program?.admissions?.[0]?.bandACompRatio),
                                style: {"padding":"2px","font-size":"0.9em","margin":"0 0 4px 0"}
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", null, [
                                    _createElementVNode("b", null, _toDisplayString(_ctx.program.admissions[0].bandACompRatio), 1),
                                    _createTextVNode(" compete for 1 seat (" + _toDisplayString(_ctx.program.admissions[0].intakeYear) + ")", 1),
                                    _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1))
                                  ])
                                ]),
                                _: 1
                              }, 8, ["color"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["isOpen", "event"])
                ]),
                _: 1,
                __: [6]
              }, 8, ["style"]),
              (_ctx.program?.admissions?.length && _ctx.program.admissions[0].bandACompRatio)
                ? (_openBlock(), _createBlock(_component_ion_badge, {
                    key: 0,
                    class: "stat-badge",
                    style: _normalizeStyle({ backgroundColor: _ctx.transparent ? 'transparent' : undefined })
                  }, {
                    default: _withCtx(() => [
                      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "stat-label" }, "Past Applicant", -1)),
                      _createElementVNode("div", {
                        class: "stat-value",
                        style: _normalizeStyle({
              //border: '1px solid #ccc',
              color: _ctx.transparent ? 'var(--ion-color-dark)' : 'white'
            })
                      }, _toDisplayString((_ctx.program.admissions[0].bandACompRatio * _ctx.program.admissions[0].numOfBandAOffers).toFixed(0)), 5)
                    ]),
                    _: 1,
                    __: [7]
                  }, 8, ["style"]))
                : _createCommentVNode("", true),
              _createVNode(_component_ion_badge, {
                class: "stat-badge",
                style: _normalizeStyle({ backgroundColor: _ctx.transparent ? 'transparent' : undefined })
              }, {
                default: _withCtx(() => [
                  _cache[8] || (_cache[8] = _createElementVNode("div", { class: "stat-label" }, "Interview", -1)),
                  _createElementVNode("div", {
                    class: "stat-value",
                    style: _normalizeStyle({
              //border: '1px solid #ccc',
              color: _ctx.transparent ? 'var(--ion-color-dark)' : 'white'
            })
                  }, [
                    (_ctx.program?.interviewArrangements?.includes('Yes'))
                      ? (_openBlock(), _createBlock(_component_ion_icon, {
                          key: 0,
                          icon: _ctx.checkmark
                        }, null, 8, ["icon"]))
                      : (_ctx.program?.interviewArrangements?.includes('No'))
                        ? (_openBlock(), _createBlock(_component_ion_icon, {
                            key: 1,
                            icon: _ctx.close
                          }, null, 8, ["icon"]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_9, "-"))
                  ], 4)
                ]),
                _: 1,
                __: [8]
              }, 8, ["style"])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.showNames)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createVNode(_component_ProgramItemContent, {
              item: _ctx.program,
              fromDeckView: true,
              hideDisciplineBadges: true,
              showRecommendedEvents: false
            }, null, 8, ["item"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}